module.exports = ['$analytics', '$uibModal', roleSelectorModal];

function roleSelectorModal($analytics, $uibModal) {
    var modal = {
        show: showModal
    };

    roleSelectorModal.$inject = ['$uibModalInstance', 'roleGroups'];

    function roleSelectorModal($uibModalInstance, roleGroups) {
        var vm = {
            $onInit: attached,
            allRolesAreSelected: roleGroups.every(x => x.isSelected),
            roleGroups: roleGroups,
            filter : '',
            close: close,
            changeFilter: changeFilter,
            clearFilter: clearFilter,
            changeRoleGroup: changeRoleGroup,
            changeRoleSelected: changeRoleSelected,
            changeRoleGroupSelected: changeRoleGroupSelected,
            changeSelectAllRoles: changeSelectAllRoles
        };

        function attached() {
            roleGroups.forEach((roleGroup) => {
                roleGroup.selectedRoleCount = roleGroup.Roles.filter(x => x.isSelected).length;
            });
            changeFilter();
        }

        function close() {
            $uibModalInstance.close();
        }

        function changeSelectAllRoles() {
            vm.roleGroups.forEach((roleGroup) => {
                roleGroup.isSelected = vm.allRolesAreSelected;
                roleGroup.Roles.forEach((role) => {
                    role.isSelected = vm.allRolesAreSelected;
                });
                roleGroup.selectedRoleCount = roleGroup.Roles.filter(x => x.isSelected).length;
            });
        }

        function changeRoleGroupSelected(roleGroup) {
            roleGroup.Roles.forEach((role) => {
                role.isSelected = roleGroup.isSelected;
            });
            roleGroup.selectedRoleCount = roleGroup.Roles.length;
            vm.allRolesAreSelected = vm.roleGroups.every(x => x.isSelected);
        }

        function changeRoleSelected(role) {
            var roleGroup = vm.roleGroups.find(x => x.Name === role.RoleGroupName);
            roleGroup.isSelected = roleGroup.Roles.every(x => x.isSelected);
            roleGroup.selectedRoleCount = roleGroup.Roles.filter(x => x.isSelected).length;
            vm.allRolesAreSelected = vm.roleGroups.every(x => x.isSelected);
        }

        function matchesQueryString(role, queryString) {
            return role.Code.toLowerCase().includes(queryString.toLowerCase()) || role.Description.toLowerCase().includes(queryString.toLowerCase());
        }

        function changeFilter(queryString) {
            vm.roleGroups.forEach((roleGroup) => {
                roleGroup.Roles.forEach((role) => {
                    role.matchesFilter = matchesQueryString(role, queryString || '');
                });
                roleGroup.matchesFilter = roleGroup.Roles.some(role => role.matchesFilter);
            });
        }

        function clearFilter() {
            vm.filter = '';
            changeFilter();
        }

        function changeRoleGroup(index) {
            document
                .querySelector('.role-selector-scroll-container .role-group-' + index)
                .scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        return vm;
    }

    function showModal(roleGroups) {
        $analytics.eventTrack('open-modal-role-selector', { category: 'role-codes' });
        var modalInstance = $uibModal.open({
            animation: true,
            backdrop: true,
            bindToController: true,
            controller: roleSelectorModal,
            controllerAs: 'ctrl',
            keyboard: true,
            modalFade: true,
            resolve: {
                roleGroups: () => roleGroups
            },
            size: 'lg',
            templateUrl: 'customs-offices/modals/role-selector.html',
            windowClass: 'modal-wide'
        });

        modalInstance.rendered.then(function() {
            var elementToFocusOnInModal = document.querySelector('.modal.in .focus-on-open-modal');
            if (elementToFocusOnInModal) {
                elementToFocusOnInModal.focus();
            }
        });

        return modalInstance;
    }

    return modal;
}